import React, { useContext, useCallback } from "react";
import { modalTypes } from "../../constants";
import * as actionTypes from "./actionTypes";
import modalsReducer, { initialState } from "./modalsReducer";
import ProviderPanelModal from "../../containers/ProviderPanelModal";
import ProviderPanelProvider from "../provider-panel-context";

const ModalsContext = React.createContext();

const ModalsProvider = ({ children }) => {
  const [{ modalType, payload }, dispatch] = React.useReducer(modalsReducer, initialState);

  const openModal = useCallback(async (modalType, payload) => {
    await dispatch({ type: actionTypes.CLOSE_MODAL });
    await dispatch({
      type: actionTypes.OPEN_MODAL,
      modalType,
      payload,
    });
  }, [dispatch]);

  const closeModal = useCallback(() => {
    dispatch({ type: actionTypes.CLOSE_MODAL });
  }, [dispatch]);

  return (
    <ModalsContext.Provider
      value={{
        openModal,
        closeModal,
      }}
    >
      {children}

      {modalType === modalTypes.PROVIDER_PANEL_MODAL && (
        <ProviderPanelProvider {...payload}>
          <ProviderPanelModal />
        </ProviderPanelProvider>
      )}
    </ModalsContext.Provider>
  );
};

export const useModals = () => {
  const context = useContext(ModalsContext);

  if (context === undefined) {
    throw new Error("useModals must be used within a ModalsProvider");
  }

  return context;
};

export default ModalsProvider;
